import gql from 'graphql-tag'

export const EMPLOYEES_QUERY = gql`
  query GetEmployees {
    employees {
      id
      name
      photoUrl
      email
      permission
      createdAt
      updatedAt
      isActive
      Department { id name }
      managers { id name positionRow positionCol }
      roles { id name }
      positionRow
      positionCol
    }
  }
`

export const UPDATE_EMPLOYEE_MUTATION = gql`
  mutation UpdateEmployee($id: String!, $input: UpdateEmployeeInput!) {
    updateEmployee(id: $id, input: $input) {
      id
      name
      email
      permission
      departmentId
      Department { id name }
      updatedAt
    }
  }
`

export const DELETE_EMPLOYEE_MUTATION = gql`
  mutation DeleteEmployee($id: String!) {
    deleteEmployee(id: $id)
  }
`

export const DEACTIVATE_EMPLOYEE_MUTATION = gql`
  mutation DeactivateEmployee($id: String!, $reason: String!) {
    deactivateEmployee(id: $id, reason: $reason) {
      id
      name
      email
      updatedAt
      isActive
      terminatedAt
      terminationReason
    }
  }
`

export const DEPARTMENTS_QUERY = gql`
  query Departments {
    departments { id name }
  }
`

export const ROLES_QUERY = gql`
  query Roles {
    roles { id name }
  }
`

export const SET_EMPLOYEE_ROLES_MUTATION = gql`
  mutation SetEmployeeRoles($employeeId: String!, $roleIds: [Int!]!) {
    setEmployeeRoles(employeeId: $employeeId, roleIds: $roleIds) {
      id
      roles { id name }
    }
  }
`

export const SET_EMPLOYEE_MANAGERS_MUTATION = gql`
  mutation SetEmployeeManagers($employeeId: String!, $managerIds: [String!]!) {
    setEmployeeManagers(employeeId: $employeeId, managerIds: $managerIds) {
      id
      managers { id name }
    }
  }
`

export const SET_EMPLOYEE_POSITION_MUTATION = gql`
  mutation SetEmployeePosition($employeeId: String!, $row: Int!, $col: Int!) {
    setEmployeePosition(employeeId: $employeeId, row: $row, col: $col) {
      id
      positionRow
      positionCol
    }
  }
`

export const SET_EMPLOYEES_POSITIONS_MUTATION = gql`
  mutation SetEmployeesPositions($input: [EmployeePositionInput!]!) {
    setEmployeesPositions(input: $input) { id positionRow positionCol }
  }
`

export const UPLOAD_EMPLOYEE_PHOTO_MUTATION = gql`
  mutation UploadEmployeePhoto($employeeId: String!, $fileData: String!, $mimeType: String!, $fileName: String!) {
    uploadEmployeePhoto(employeeId: $employeeId, fileData: $fileData, mimeType: $mimeType, fileName: $fileName) {
      id
      photoUrl
    }
  }
`

export const UPLOAD_EMPLOYEE_DOCUMENT_MUTATION = gql`
  mutation UploadEmployeeDocument($employeeId: String!, $fileData: String!, $name: String!, $mimeType: String!, $size: Int!) {
    uploadEmployeeDocument(employeeId: $employeeId, fileData: $fileData, name: $name, mimeType: $mimeType, size: $size) {
      id
      name
      fileUrl
      mimeType
      size
      uploadedAt
    }
  }
`

export const DELETE_EMPLOYEE_DOCUMENT_MUTATION = gql`
  mutation DeleteEmployeeDocument($id: Int!) {
    deleteEmployeeDocument(id: $id)
  }
`

export const MANUAL_CHECK_IN_MUTATION = gql`
  mutation ManualCheckIn {
    manualCheckIn {
      id
      employeeId
      name
      date
      checkIn
      checkOut
      secondCheckIn
      secondCheckOut
      pauses {
        id
        startAt
        endAt
      }
    }
  }
`

export const MANUAL_CHECK_OUT_MUTATION = gql`
  mutation ManualCheckOut {
    manualCheckOut {
      id
      employeeId
      name
      date
      checkIn
      checkOut
      secondCheckIn
      secondCheckOut
      pauses {
        id
        startAt
        endAt
      }
    }
  }
`

export const START_PAUSE_MUTATION = gql`
  mutation StartPause {
    startPause {
      id
      employeeId
      name
      date
      checkIn
      checkOut
      secondCheckIn
      secondCheckOut
      pauses {
        id
        startAt
        endAt
      }
    }
  }
`

export const END_PAUSE_MUTATION = gql`
  mutation EndPause {
    endPause {
      id
      employeeId
      name
      date
      checkIn
      checkOut
      secondCheckIn
      secondCheckOut
      pauses {
        id
        startAt
        endAt
      }
    }
  }
`
